import type { ReactNode } from "react";

interface AudioLabDownloadButtonProps {
  label: string;
  icon: ReactNode;
  onClick: () => void;
  disabled?: boolean;
  busy?: boolean;
  title?: string;
  variant?: "primary" | "secondary" | "quiet";
}

export function AudioLabDownloadButton({
  label,
  icon,
  onClick,
  disabled = false,
  busy = false,
  title,
  variant = "secondary"
}: AudioLabDownloadButtonProps) {
  return (
    <button
      className={`audio-lab-button is-${variant}`}
      type="button"
      disabled={disabled || busy}
      title={title}
      onClick={onClick}
    >
      {icon}
      <span>{busy ? "Generating" : label}</span>
    </button>
  );
}
